// Shared inline error banner — used across the monitoring dashboards so any
// SWR hook with a failed fetch shows a clear red banner instead of a forever
// spinner. Pass the raw SWR `error` value; the component reads `.message`
// off Error instances and falls back to String(err) otherwise.

export function ErrorBanner({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error ?? 'Unknown error');
  return (
    <div className="rounded ring-1 ring-rose-800 bg-rose-950/40 px-3 py-2 text-sm text-rose-200">
      <span className="font-semibold">Failed to load.</span>{' '}
      <span className="text-rose-300/90">{msg}</span>
    </div>
  );
}
